module.exports = __webpack_public_path__ + "static/highway-yellow-8fd407d94e254bbcf2100dbc08daf5a8.png";